export const merchants = {
  paging: { total: 8, count: 100000, totalPages: 1, currentPage: 0 },
  merchants: [
    {
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      shortDescription: 'Dev Team Only',
      longDescription: 'Test Merchant',
      title: 'Dev Team Only',
      address: {
        streetAddress1: '19 Crosby Drive,',
        streetAddress2: null,
        city: 'Bedford, MA',
        postalCode: '01730',
        region: 'Massachusetts',
        country: 'United States',
      },
      clientId: null,
      messageFromEmail: 'nirasha.aet@gmail.com',
      timezone: 'Asia/Colombo',
    },
    {
      merchantId: '84ace984-71ec-4488-b7fd-cb7bc24a881c',
      shortDescription: 'Merchant for ElastiCache redis migration testing',
      longDescription: null,
      title: 'ElastiCache Testing',
      address: {
        streetAddress1: '3333 Monument Road',
        streetAddress2: null,
        city: 'Jacksonville',
        postalCode: '32225',
        region: 'Florida',
        country: 'United States',
      },
      clientId: null,
      messageFromEmail: 'bobm@incentivio.com',
      timezone: 'Asia/Colombo',
    },
    {
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      shortDescription: 'INCENTIVIO',
      longDescription: 'INCENTIVIO',
      title: 'INCENTIVIO',
      address: {
        streetAddress1: '19 Crosby Drive,',
        streetAddress2: 'Suite 160',
        city: 'Bedford, MA',
        postalCode: '01730',
        region: 'Massachusetts',
        country: 'United States',
      },
      clientId: null,
      messageFromEmail: 'palmlanedevmembers@incentiviodev.com',
      timezone: 'Asia/Colombo',
    },
    {
      merchantId: '9458ce51-e44a-451a-b8a3-beb15d1ddbaf',
      shortDescription: 'Otter Demo',
      longDescription: 'Otter Demo',
      title: 'Otter Demo',
      address: {
        streetAddress1: '575 Boylston Street',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '02116',
        region: 'Massachusetts',
        country: 'United States',
      },
      clientId: null,
      messageFromEmail: 'mattg@incentivio.com',
      timezone: 'America/New_York',
    },
    {
      merchantId: '5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca',
      shortDescription: 'Qu Demo',
      longDescription: 'Qu Demo',
      title: 'Qu Demo',
      address: {
        streetAddress1: '575 Boylston St',
        streetAddress2: '3L',
        city: 'BOSTON',
        postalCode: '02116',
        region: 'Massachusetts',
        country: 'United States',
      },
      clientId: null,
      messageFromEmail: 'mattg@incentivio.com',
      timezone: 'America/New_York',
    },
    {
      merchantId: '73c25df9-b8d5-4d89-9944-dbbdc0c8a117',
      shortDescription: 'Test',
      longDescription: null,
      title: 'test',
      address: {
        streetAddress1: 'No 223 boston road',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12122',
        region: 'Massachusetts',
        country: 'United States',
      },
      clientId: null,
      messageFromEmail: 'dinusha.a@aeturnum.com',
      timezone: 'America/New_York',
    },
    {
      merchantId: '2da058d7-1077-4548-bcab-0e919bdaeb38',
      shortDescription: 'test merchant2',
      longDescription: null,
      title: 'test merchant 2',
      address: {
        streetAddress1: 'No 223 boston road',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12122',
        region: 'Massachusetts',
        country: 'United States',
      },
      clientId: null,
      messageFromEmail: 'dinusha.a@aeturnum.com',
      timezone: 'Asia/Colombo',
    },
    {
      merchantId: '4ec03358-386c-48bb-be4d-f36400f0de1e',
      shortDescription: 'Test Merchant2',
      longDescription: 'Test Merchant',
      title: 'Test Merchant2',
      address: {
        streetAddress1: 'No 223 boston road',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12122',
        region: 'Massachusetts',
        country: 'United States',
      },
      clientId: null,
      messageFromEmail: 'dinusha.a@aeturnum.com',
      timezone: 'Asia/Colombo',
    },
  ],
};

export const getMerchant = {
  merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
  shortDescription: 'Dev Team Only',
  longDescription: 'Test Merchant',
  title: 'Dev Team Only',
  address: {
    streetAddress1: '19 Crosby Drive,',
    streetAddress2: null,
    city: 'Bedford, MA',
    postalCode: '01730',
    region: 'Massachusetts',
    country: 'United States',
  },
  clientId: null,
  messageFromEmail: 'nirasha.aet@gmail.com',
  timezone: 'Asia/Colombo',
};
